import { Balance } from 'components/Balance/Balance';
import { Button } from 'components/Button/Button';
import { Card } from 'components/Card/Card';
import { Icon } from 'components/Icon/Icon';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { AppRoutes } from 'Routes';
import { useUserStore } from 'stores/user.store';

export const MemberPreviewbalance = () => {
    const user = useUserStore(state => state.user);
    const { t } = useTranslation('company');

    if (!user) return null;

    return (
        <Card className="flex justify-between">
            <div className="flex flex-col gap-8">
                <div className="text-lg font-semibold">{t('balance')}</div>
                <div className="text-2xl font-semibold text-rose-700">
                    <Balance balance={user?.balance} />
                    {user?.remainderBalance > 0 && (
                        <div className="text-xs text-zinc-400">
                            {t('remainderBalance')}
                            <Balance
                                balance={{
                                    amount: user.remainderBalance,
                                    currency: 'CHF',
                                }}
                            />
                        </div>
                    )}
                </div>
            </div>
            <div className="flex gap-2">
                <Button variant="outline" asChild>
                    <Link to={AppRoutes.editMember.replace(':id', user?.id)}>
                        <Icon name="edit" className="h-4 mr-2" />
                        {t('editProfileButton')}
                    </Link>
                </Button>
                <Button asChild>
                    <Link to={AppRoutes.memberProfile.replace(':id', user?.id)}>{t('viewProfileButton')}</Link>
                </Button>
            </div>
        </Card>
    );
};
